import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'src/config';

export type RiskMaterialityFactor = {
    sourceKey: string;
    description: string;
};

type CmsRiskMaterialityEntry = {
    attributes: {
        source_key: string;
        description: string;
    };
};

const riskMaterialityCmsSlice = createApi({
    reducerPath: 'riskMaterialityCmsApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.cmsApiUrl }),
    endpoints: builder => ({
        getRiskMaterialityFactors: builder.query<RiskMaterialityFactor[], void>({
            query: () => `/risk-materialities?pagination[pageSize]=999`,
            transformResponse: (response: { data: CmsRiskMaterialityEntry[] }) =>
                response.data.map(entry => ({
                    sourceKey: entry.attributes.source_key,
                    description: entry.attributes.description,
                })),
        }),
    }),
});

export const { useGetRiskMaterialityFactorsQuery } = riskMaterialityCmsSlice;
export default riskMaterialityCmsSlice;
